<template>
  <!-- 生产单详情 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="refreshPage()"
        style=""
        size="mini"
        icon="el-icon-refresh"
        >刷新</el-button
      >

      <el-button
        type="primary"
        @click="previousRecord()"
        style=""
        size="mini"
        icon="el-icon-arrow-up"
        >上一条</el-button
      >
      <el-button
        type="primary"
        @click="nextRecord()"
        style=""
        size="mini"
        icon="el-icon-arrow-down"
        >下一条</el-button
      >

      <el-button
        v-if="this.workOrderInfo.status === 1"
        type="success"
        @click="checkWorkorder(2)"
        style=""
        size="mini"
        icon="el-icon-check"
        >审核通过</el-button
      >
      <el-button
        v-if="this.workOrderInfo.status === 1"
        type="danger"
        @click="checkWorkorder(0)"
        style=""
        size="mini"
        icon="el-icon-close"
        >审核不通过</el-button
      >

      <el-button
        v-if="
          this.workOrderInfo.status === 2 &&
            (this.workOrderInfo.workStatus === 1 ||
              this.workOrderInfo.workStatus === 2)
        "
        type="default"
        @click="switchWorkorder(2)"
        style=""
        size="mini"
        >上单</el-button
      >
      <el-button
        v-if="
          this.workOrderInfo.status === 2 && this.workOrderInfo.workStatus === 3
        "
        type="default"
        @click="switchWorkorder(1)"
        style=""
        size="mini"
        >下单</el-button
      >

      <!-- 上机状态=上机，表示生产中，不能"结案"，必须先下机。 -->
      <el-button
        v-if="
          this.workOrderInfo.status === 2 &&
            this.workOrderInfo.workStatus !== 3 &&
            this.workOrderInfo.workStatus !== 4
        "
        type="success"
        @click="closeWorkorder()"
        style=""
        size="mini"
        >结案</el-button
      >

      <!-- <el-button type="primary" @click="initPrint('gongDanDetail')" size="mini" icon="el-icon-printer">打印</el-button> -->
      <!-- 调用liuqy新打印页面 -->
      <el-button
        type="primary"
        @click="goNewPrint()"
        size="mini"
        icon="el-icon-printer"
        >打印</el-button
      >

      <el-button
        type="primary"
        @click="copyWorkorder()"
        size="mini"
        icon="el-icon-copy-document"
        >复制</el-button
      >

      <!-- status=0 待提交 才可以进行编辑 -->
      <el-button
        v-if="this.workOrderInfo.status === 0"
        type="primary"
        @click="editWorkorder()"
        size="mini"
        icon="el-icon-edit"
        >编辑</el-button
      >
    </div>

    <div id="gongDanDetail">
      <work-order-header-info ref="orderHeaderInfo" />
      <!-- <br /> -->
      <!-- 换行 -->
      <!-- <work-order-craft-info ref="craftInfo"/> -->
    </div>

    <div class="rzy-top-bar" style="margin-top: 10px;">
      <div>
        制单时间:
        {{ this.utils.timestampToTime(this.workOrderInfo.createTime) }}
      </div>
      <div style="margin: auto;">
        审核时间: {{ this.utils.timestampToTime(this.workOrderInfo.checkTime) }}
      </div>
      <div style="margin-left: auto;">
        结案时间: {{ this.utils.timestampToTime(this.workOrderInfo.closeTime) }}
      </div>
    </div>
  </div>
</template>

<script>
import { workOrderHeaderInfo } from "./components";
export default {
  components: { workOrderHeaderInfo },
  data() {
    return {
      workOrderInfo: {},
      lastWorkOrderId: 0, // 上一条/下一条 切换后，记录最新的 工单ID
      //avoidMultiPopFlag: false, // false: 无错误弹窗，true: 错误弹窗中。
    };
  },
  methods: {
    // 根据ID，获取工单信息
    getworkOrderInfo(workOrderId) {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/detail",
        method: "get",
        params: { id: workOrderId },
      }).then((res) => {
        res = res.data;
        this.workOrderInfo = res;
        this.$refs.orderHeaderInfo.setworkOrderHeader(res);
        // this.$refs.craftInfo.setCraftOrder(res.craftsheet);
      });
    },

    // 在打印当前报表前，拼接title
    initPrint(id) {
      this.utils.printTable(id, `工单详情`);
    },
    // 刷新
    refreshPage() {
      this.getworkOrderInfo(this.lastWorkOrderId);
      this.avoidMultiPop("刷新成功。");
    },
    // 上一条记录
    previousRecord() {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/prev",
        method: "get",
        params: { id: this.lastWorkOrderId },
      }).then((res) => {
        res = res.data;

        if (res != undefined) {
          this.workOrderInfo = res;
          this.$refs.orderHeaderInfo.setworkOrderHeader(res);
        //   this.$refs.craftInfo.setCraftOrder(res.craftsheet);
          this.lastWorkOrderId = res.id; //更新工单ID
          this.avoidMultiPop("切换上一条记录成功。");
        } else {
          // null 表示数据库 到顶 或者 到底。
          this.avoidMultiPop("没有更多数据。");
        }
      });
    },
    // 下一条记录
    nextRecord() {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/next",
        method: "get",
        params: { id: this.lastWorkOrderId },
      }).then((res) => {
        res = res.data;

        if (res != undefined) {
          this.workOrderInfo = res;
          this.$refs.orderHeaderInfo.setworkOrderHeader(res);
        //   this.$refs.craftInfo.setCraftOrder(res.craftsheet);
          this.lastWorkOrderId = res.id; //更新工单ID
          this.avoidMultiPop("切换下一条记录成功。");
        } else {
          // null 表示数据库 到顶 或者 到底。
          this.avoidMultiPop("没有更多数据。");
        }
      });
    },
    //避免重复弹窗
    avoidMultiPop(message) {
      this.$Message.closeAll();
      this.$Message.success(message);
      /*if(this.avoidMultiPopFlag) return
            this.avoidMultiPopFlag = true
            let that = this // setTimeout中this指向window，不是所在对象。
            setTimeout(function (){
                that.$Message.success(message)
                that.avoidMultiPopFlag = false
            }, 2000);*/
    },
    // 审核通过 or 审核不通过
    checkWorkorder(status) {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/check",
        method: "POST",
        data: {
          data: {
            machineId: this.workOrderInfo.machineId, // 机台ID
            orderNum: this.workOrderInfo.number, // 工单号
            status: status, // 0=审核不通过(待提交), 1=未审核(待审), 2=已审核(已审)
          },
        },
      }).then((res) => {
        res = res.data;
        this.refreshPage(); //刷新页面
      });
    },

    doSwitchWorkorder(type) {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/switch",
        method: "POST",
        data: {
          data: {
            machineId: this.workOrderInfo.machineId, // 机台ID
            nowOrderNum: this.workOrderInfo.number, // 上机工单号
            oldOrderNum: this.workOrderInfo.number, // 下机工单号
            type: type, // 0切换, 1下机, 2上机
          },
        },
      }).then((res) => {
        res = res.data;
        this.refreshPage(); //刷新页面
      });
    },

    // 上单 or 下单
    switchWorkorder(type) {
      this.$confirm("工单下机后可操作", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          this.doSwitchWorkorder(type);
        })
        .catch(() => {
          //点取消的提示
        });
    },

    doCloseWorkorder: function() {
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/close",
        method: "POST",
        data: {
          data: {
            machineId: this.workOrderInfo.machineId, // 机台ID
            orderNum: this.workOrderInfo.number, // 上机工单号
          },
        },
      }).then((res) => {
        res = res.data;
        this.refreshPage(); //刷新页面
      });
    },
    // 结案
    closeWorkorder() {
      this.$confirm("结案后，工单将进行封存保留。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //点击确定的操作(调用接口)
          this.doCloseWorkorder();
        })
        .catch(() => {
          //点取消的提示
        });
    },
    // 复制工单
    copyWorkorder() {
      this.$router.push({
        path: `../beamWarpingAdd`,
        query: {
          type: 2, //0=新建, 1=编辑, 2=复制.
          workOrderId: this.$route.params.id,
        },
      });
    },
    // 编辑工单
    editWorkorder() {
      this.$router.push({
        path: `../beamWarpingAdd`,
        query: {
          type: 1, //0=新建, 1=编辑, 2=复制.
          workOrderId: this.$route.params.id,
        },
      });
    },

    // 调用liuqy新打印页面
    goNewPrint() {
      this.$router.push({
        path: `../beamWarpingPrint`,
        query: {
          data: this.workOrderInfo,
        },
      });
    },
  },
  created() {
    this.getworkOrderInfo(this.$route.params.id);

    this.lastWorkOrderId = this.$route.params.id; //初始化时候 备份 工单ID.
  },
};
</script>

<style lang="scss" scoped></style>
